// Words used everywhere (GIOTHUB-185). English defines the keys.
import type { Dict } from "./dict";

const en = {
  "common.language": "Language",
  "common.help": "Help",
  "common.loading": "Loading…",
  "common.signingin": "Signing in…",
  "common.notfound": "Page not found.",
  "common.copy": "Copy",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.yes": "Yes",
  "common.no": "No",
  "common.manual.english": "The manual is in English.",
  "role.admin": "administrator",
  "role.builder": "builder",
  "role.viewer": "viewer",
  "nav.projects": "Projects",
  "nav.members": "Members",
  "nav.organisations": "Organisations",
  "nav.organisation": "Organisation",
  "nav.signout": "Sign out",
} as const;

const de = {
  "common.language": "Sprache",
  "common.help": "Hilfe",
  "common.loading": "Wird geladen…",
  "common.signingin": "Anmeldung…",
  "common.notfound": "Seite nicht gefunden.",
  "common.copy": "Kopieren",
  "common.save": "Speichern",
  "common.cancel": "Abbrechen",
  "common.close": "Schliessen",
  "common.delete": "Löschen",
  "common.edit": "Bearbeiten",
  "common.yes": "Ja",
  "common.no": "Nein",
  "common.manual.english": "Das Handbuch ist auf Englisch.",
  "role.admin": "Administrator",
  "role.builder": "Entwickler",
  "role.viewer": "Betrachter",
  "nav.projects": "Projekte",
  "nav.members": "Mitglieder",
  "nav.organisations": "Organisationen",
  "nav.organisation": "Organisation",
  "nav.signout": "Abmelden",
} satisfies Dict<typeof en>;

const it = {
  "common.language": "Lingua",
  "common.help": "Aiuto",
  "common.loading": "Caricamento…",
  "common.signingin": "Accesso in corso…",
  "common.notfound": "Pagina non trovata.",
  "common.copy": "Copia",
  "common.save": "Salva",
  "common.cancel": "Annulla",
  "common.close": "Chiudi",
  "common.delete": "Elimina",
  "common.edit": "Modifica",
  "common.yes": "Sì",
  "common.no": "No",
  "common.manual.english": "Il manuale è in inglese.",
  "role.admin": "amministratore",
  "role.builder": "sviluppatore",
  "role.viewer": "lettore",
  "nav.projects": "Progetti",
  "nav.members": "Membri",
  "nav.organisations": "Organizzazioni",
  "nav.organisation": "Organizzazione",
  "nav.signout": "Esci",
} satisfies Dict<typeof en>;

const fr = {
  "common.language": "Langue",
  "common.help": "Aide",
  "common.loading": "Chargement…",
  "common.signingin": "Connexion…",
  "common.notfound": "Page introuvable.",
  "common.copy": "Copier",
  "common.save": "Enregistrer",
  "common.cancel": "Annuler",
  "common.close": "Fermer",
  "common.delete": "Supprimer",
  "common.edit": "Modifier",
  "common.yes": "Oui",
  "common.no": "Non",
  "common.manual.english": "Le manuel est en anglais.",
  "role.admin": "administrateur",
  "role.builder": "développeur",
  "role.viewer": "lecteur",
  "nav.projects": "Projets",
  "nav.members": "Membres",
  "nav.organisations": "Organisations",
  "nav.organisation": "Organisation",
  "nav.signout": "Se déconnecter",
} satisfies Dict<typeof en>;

export default { en, de, it, fr };
